import { nanoid } from "nanoid";
import type { AppLoadContext } from "@remix-run/cloudflare";
import { CloudflareENV } from "../interfaces";

export const getKey = (file: File, folderName?: string) => {
  const ext = file.name.split(".").pop();
  const name = folderName ? `${folderName}/${nanoid()}` : nanoid();
  return `${name}.${ext}`;
};

export const getImage = (keyname: string | null | undefined) => {
  if (!keyname) return null;
  if (process.env.NODE_ENV === "production") {
    return `/media/${keyname}`;
  }
  return `http://localhost:8788/media/${keyname}`;
};

export const getFileUrl = (keyname: string) => {
  const baseUrl =
    process.env.NODE_ENV === "production"
      ? window.location.origin
      : "http://localhost:8788";

  return `${baseUrl}/media/${keyname}`;
};

export const downloadFile = (keyname: string, fileName: string) => {
  const url = getFileUrl(keyname);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};



export const uploadFile = async (
  context: AppLoadContext,
  file: File,
  config?: {
    folderName: string;
  }
) => {
  const env = context.cloudflare.env as CloudflareENV;
  const fileKey = getKey(file, config?.folderName);
  await env.R2.put(fileKey, file);
  return fileKey;
};

export const extractKeyFromUrl = (url: string): string | null => {
  try {
    // Handle both full URLs and relative paths
    const mediaPath = url.split('/media/')[1];
    if (!mediaPath) return null;
    
    // Remove any query parameters
    return mediaPath.split('?')[0];
  } catch (error) {
    console.error('Error extracting key from URL:', error);
    return null;
  }
};

export const getFileFromR2 = async (context: AppLoadContext, urlOrKey: string) => {
  const env = context.cloudflare.env as CloudflareENV;
  
  // Extract key from URL if needed
  const fileKey = urlOrKey.includes('/media/') ? extractKeyFromUrl(urlOrKey) : urlOrKey;
  
  if (!fileKey) {
    console.error('Invalid file key or URL:', urlOrKey);
    return null;
  }

  try {
    const object = await env.R2.get(fileKey);
    if (!object) return null;
    
    return object;
  } catch (error) {
    console.error('Error getting file from R2:', error);
    return null;
  }
}